/**
 * Created by Thomas Mark
 * Date: 2021-04-02
 * 
 * Dieser Dialog bietet die Möglichkeit Release-Informationen zu erfassen
 * Der Benutzer erfährt hier, welche inhaltlichen Änderungen im aktuellen Katalog  
 * durchgeführt wurden.
 * 
 * Wird eine Änderung durchgeführt, so wird auch gleichzeitig ein Zeitstempel 
 * mit dem aktuellen Datum und Uhrzeit gesichert. Im ContainersController kann
 * der aktuelle Zeitstempel der neuesten Live-Version mit dem Zeitstempel der
 * zuletzt geladenen Live-Version verglichen werden, um den Benutzer zu signalisieren, 
 * dass eine neuere Version existiert, die heruntergeladen werden kann/soll. 
 * 
 * Der Dialog kann nur durch einen Administrator gestartet werden.
 * 
 * Änderungen werden auf dem Server in der Datei 'settings.json' gespeichert.
 *  
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import * as utils from "../../../basics/utils";
import * as appActions from "../../../store/actions/appActions";
import * as fileActions from "../../../store/actions/fileActions";
import * as syncActions from "../../../store/actions/syncActions";
import * as settingActions from "../../../store/actions/settingActions";
import { ModalTitle } from "../../partials/ModalTitle";

/* ag-grid-react */
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';

class ReleaseNotesModal extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;

        this.component = 'ReleaseNotesModal';

        this.state = {
            releaseNotes: {},
            validationError: false,
            validationMessage: "",
        }

        this.agGridRightApi = null;
        this.agGridRightColumnApi = null;
        this.agGridRightWidth = 500;
        this.agGridRightVisibleItems = 5;

        this.agGridRowHeight = 40;
        this.agGridHeaderHeight = 0;

        this.timestamp = 0;
    }

    // ==========================================================================
    //
    // HELPER - SECTION
    //
    // ==========================================================================

    validateWidget = (id, value) => {
        this.debug && console.log(`validateWidget(${id}, ${value})`);

        let newState = { validationError: false, validationMessage: '' };

        // Feld 'name' prüfen
        if (id === 'headline' || id === 'introduction') {
            if (/[^-&öüäÖÜÄß\w+( +\w+)*$]/.test(value)) {
                newState = { validationError: true, validationMessage: 'Wert ist ungültig!' };
            }
        }

        // Prüfen, ob Feld leer ist
        if (value === '') {
            newState = { validationError: true, validationMessage: 'Feld darf nicht leer sein!' };
        }

        this.debug && console.log(newState);

        this.setState(newState);
    }

    // ==========================================================================
    //
    // LIFESYCLE - SECTION
    //
    // ==========================================================================

    componentDidUpdate(prevProps) {
        const { modalDialog, windowWidth } = this.props.app;
        const { settingList } = this.props.setting;

        this.agGridRightWidth = windowWidth * 1;

        if (modalDialog.dialog === this.component && modalDialog.dialog !== prevProps.app.modalDialog.dialog) {
            console.log('componentDidUpdate() newReleaseNotes', settingList.releaseNotes)

            this.setState({ releaseNotes: settingList.releaseNotes })
        }
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { modalDialog } = this.props.app;
        const { releaseNotes, validationError, validationMessage } = this.state;

        let newReleaseNotes = releaseNotes;

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================

        const renderTextField = (id, label, type, autoFocus, disabled) => {

            const onChangeTextField = (e) => {
                this.validateWidget(e.target.id, e.target.value);

                newReleaseNotes[e.target.id] = e.target.value;

                this.setState({ releaseNotes: newReleaseNotes });
            }

            return (
                <TextField
                    autoFocus={autoFocus}
                    id={id}
                    label={label}
                    type={type}
                    fullWidth
                    disabled={disabled}
                    value={this.state.releaseNotes[id]}
                    onChange={onChangeTextField}
                    InputLabelProps={{ shrink: true }}
                    margin="normal"
                />
            )
        }

        const renderActionColumn = (d) => {


            const onDelete = (event) => {
                this.timestamp = new Date().getTime();

                let newReleaseNotes = releaseNotes;

                newReleaseNotes.notes.splice(event.rowIndex, 1);

                this.setState({ releaseNotes: newReleaseNotes });
            }

            return (
                <div><DeleteIcon onClick={() => onDelete(d)} /></div>
            )
        }

        // = RECHTE TABELL ==========================================================
        // 
        // rechtes AG-GRID für Produckt-Eigenschaften
        // 
        // ==========================================================================
        const renderDetailList = () => {

            // Allgemeine AG-Grid Konfiguration
            const defaultColDef = {
                sortable: false,
                editable: false,
                filter: false,
                resizable: false,
                enableValue: false,
                enableRowGroup: false,
                enablePivot: false
            }

            // Spalten konfigurieren    
            const columnsDefsRight = [
                {
                    headerName: "",
                    field: "topic",
                    cellStyle: (params) => { return { textAlign: 'left' } },
                    editable: true,
                    rowDrag: true,
                },
                {
                    headerName: "",
                    field: "action",
                    type: 'rightAligned',
                    width: this.agGridRightWidth * .005,
                    editable: false,
                    cellRenderer: "actionRenderer",
                }
            ];

            // Inizalisierung
            const onGridRightReady = (params) => {
                this.agGridRightApi = params.api;
                this.agGridRightColumnApi = params.columnApi;
                params.api.sizeColumnsToFit();
            }

            // callbacks
            const onChange = (d) => {
                //console.log('onChange()', d);
            }

            const onCellClicked = (event) => {
                //console.log('onCellClicked()', event);
            }

            // ###############################################################
            // renderDetailList()
            // ###############################################################
            const height = this.agGridRightVisibleItems * this.agGridRowHeight + this.agGridHeaderHeight + 1;

            return (
                <div key={this.timestamp} className="w-full ag-theme-material" style={{ height: height + 'px' }}>
                    <AgGridReact
                        id="myGridReorder"
                        onGridReady={onGridRightReady}

                        // General definitions
                        sideBar={false}

                        // Column
                        columnDefs={columnsDefsRight}
                        defaultColDef={defaultColDef}

                        // Row
                        rowData={this.state.releaseNotes.notes}
                        rowHeight={this.agGridRowHeight}
                        rowSelection={"single"}
                        rowMultiSelectWithClick={false}
                        onRowDragEnd={onChange}
                        onCellValueChanged={onChange}
                        rowDragManaged={true}
                        onCellClicked={onCellClicked}

                        // Header
                        headerHeight={this.agGridHeaderHeight}

                        // Pagination
                        pagination={false}
                        paginationAutoPageSize={false}
                        suppressScrollOnNewData={false}

                        // Editing
                        singleClickEdit={false}

                        // cell renderer
                        frameworkComponents={{
                            actionRenderer: renderActionColumn
                        }}
                    />
                </div>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================
        if (modalDialog.dialog !== this.component) return null;

        const onCancel = () => {
            this.props.setModalDialog(null, null)
        }

        const onSave = () => {
            let newReleaseNotes = releaseNotes;

            newReleaseNotes['timestamp'] = utils.toSqlDatetime(new Date());

            this.props.updateSetting('releaseNotes', newReleaseNotes);

            // ModalDialog beenden
            this.props.setModalDialog(null, null)
        }

        const onCreate = () => {
            this.timestamp = new Date().getTime();

            let newReleaseNotes = releaseNotes;

            newReleaseNotes.notes.unshift({ topic: 'neues topic' });

            this.setState({ releaseNotes: newReleaseNotes });
        }

        const dialogTitle = 'ReleaseNotes';

        return (
            <Dialog fullWidth={true} maxWidth="md" open={true} onClose={onCancel} style={{ zIndex: 100 }}>
                <ModalTitle onClose={onCancel}>{dialogTitle}</ModalTitle>
                <DialogContent>
                    {renderTextField('headline', 'Überschrift', 'text', false, false)}
                    {renderTextField('introduction', 'Einleitung', 'text', true, false)}
                    <DialogActions >
                        <Button onClick={onCreate} variant="contained" color="primary" startIcon={<AddIcon />} >Neu</Button>
                    </DialogActions>
                    <Grid item xs={12}>
                        {renderDetailList()}
                    </Grid>
                    <DialogActions>
                        <Button onClick={onCancel} variant="outlined" color="default" >Abbruch</Button>
                        <div className="flex-grow"></div>
                        <Button onClick={onSave} variant="contained" color="primary" disabled={validationError}>OK</Button>
                    </DialogActions>
                    <Typography className="w-full px-8" variant="h6" noWrap>
                        {validationMessage === '' ? <span>&nbsp;</span> : validationMessage}
                    </Typography>
                </DialogContent>
            </Dialog>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        file: state.file,
        sync: state.sync,
        setting: state.setting,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, fileActions, syncActions, settingActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ReleaseNotesModal);